import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { EnvService } from "src/app/env.service";
let httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json", //,
    // 'x-auth': ()
  }),
};
@Injectable({
  providedIn: "root",
})
export class PathService {
  url;
  private pathEventSource = new BehaviorSubject(false);
  pathEvent$ = this.pathEventSource.asObservable();

  constructor(
    private http: HttpClient,
    private env: EnvService,
  ) {
    this.url = this.env.apiUrl;
  }
  getPath(id): Observable<any> {
    return this.http.get(this.url + `path/get/${id}`, httpOptions);
  }
  getPaths(pageSize, pageIndex, searchTerm): Observable<any> {
    return this.http.get(
      this.url + `path/get-all/${pageSize}/${pageIndex}/${searchTerm}`,
      httpOptions,
    );
  }
  createPath(data): Observable<any> {
    return this.http.post(this.url + "path/create/", data, httpOptions);
  }
  editPath(data): Observable<any> {
    return this.http.post(this.url + "path/edit/", data, httpOptions);
  }
  deletePath(data): Observable<any> {
    return this.http.post(this.url + "path/delete/", data, httpOptions);
  }
  emitPathEvent() {
    this.pathEventSource.next(true);
  }
  getPathContent(id, pageSize, pageIndex, searchTerm) {
    return this.http.get(
      this.url + `path/content/${id}/${pageSize}/${pageIndex}/${searchTerm}`,
      httpOptions,
    );
  }
  addContentToPath(data) {
    return this.http.post(this.url + `path/add-content/`, data, httpOptions);
  }
  addCourseToPath(data) {
    return this.http.post(this.url + `path/add-course/`, data, httpOptions);
  }
  deletePathContent(data) {
    return this.http.post(this.url + `path/remove-content/`, data, httpOptions);
  }
}
